import store from '@/store/index'

const userId = store.state.common.sessionInfo.userId
const firmId = store.state.common.sessionInfo.firmId

// 资金划转接口
export default {
  // 资产中心 -> 我的账户查询 marketId == 3
  param_getFundSum: {
    url: '/tclound-cacheservice/query/queryAccount',
    param: {
      firmId: firmId,
      marketId: 3,
      symbolId: 1
    }
  },
  // 资金划转市场列表
  param_findAccountByUserId: {
    url: '/intraday-marketing-system/operate/findAccountByUserId',
    param: {}
  },
  // 查询审核信息
  param_findBaseUserAuditByUserId: {
    // url: "/base-desk-query/baseUserAudit/findBaseUserAuditByUserId",
    url: 'base-desk-query/baseUserAudit/v1/getBaseUserAudit',
    param: {}
  },
  // 资金管理 -> 查询是否绑定企业账户 header中 market传18
  param_getBaseUserBindByUserId: {
    // url: '/intraday-bankchannel/qilubank/findTrader',
    url: '/base-desk-query/baseUserBindController/getBaseUserBindByUserId',
    param: {}
  },
  // 心跳
  param_queryTradeClosepl: {
    url: '/sec-trade-query/query/queryTradeClosepl?noTransition=1',
    param: {}
  },
  // 心跳 发售
  param_queryTradeCloseplsec: {
    url: '/sec-trade-query/query/queryTradeClosepl?noTransition=1',
    param: {}
  },
  // 查询代为转让站内信信息
  param_transferMsgInfo: {
    url: '/intraday-trade-query/frontTradeController/transferMsgInfo',
    param: {}
  },
  // 修改站内信息为已读
  param_updateInMsgReadFlag: {
    url: '/intraday-marketing-system/msgTemplateController/updateInMsgReadFlag',
    param: {}
  },
  // 资金列表查询
  param_mineAsset: {
    url: '/intraday-trade-query-mongo/mongoQuery/mineAssetList',
    param: {}
  },
  // 可划转资金查询
  param_mineAsset1: {
    url: '/sec-trade-query/query/mineAssetList',
    param: {}
  },
  // 资金多市场划转
  param_transferFundsOwn: {
    'url': '/intraday-marketing-system/operate/transferFundsOwn',
    'param': {
      'amount': null
      // 20220224 fromUserAccountId、toUserAccountId取消两个字段
      // 'fromUserAccountId': null,
      // 'toUserAccountId': null
    }
  },
  // 资金管理-》查询企业账户交易流水---当前
  param_queryAccountFlow: {
    url: '/tclound-cacheservice/query/queryAccountFlow',
    param: {
      firmId: null,
      sort: [
        {
          property: 'occurTime',
          direction: 'DESC'
        }
      ],
      marketId: 3,
      symbolId: 1
    }
  },
  // 资金管理-》查询企业账户交易流水---历史
  param_queryAccountFlowH: {
    url: '/tclound-cacheservice/query/queryAccountFlowH',
    param: {
      beginTime: null,
      endTime: null,
      firmId: null,
      sort: [
        {
          property: 'occurTime',
          direction: 'DESC'
        }
      ],
      marketId: 3,
      symbolId: 1
    }
  },
  // 手动还款
  param_reimbursement: {
    url: '/tclound-trade/manage/reimbursement',
    param: {}
  },
  // 资金流水---普通账户和交易员
  param_queryMyIntegralDetail: {
    url: '/intraday-margin-query/bankCacheQuery/findAccountFlow',
    param: {
      isMain: null,
      queryType: 1, // 1 分市场 2 不分市场
      userId: userId,
      typeCode: null, // 101出金 102入金 null 其它
      page: 0,
      size: 15,
      sort: [
        {
          direction: 'DESC',
          property: 'occurTime'
        }
      ]
    }
  },
  param_queryMyIntegralDetailHis: {
    url: '/intraday-margin-query/marginQuery/queryMyIntegralDetailHisEnd',
    param: {
      isMain: null,
      userId: userId,
      starTime: '', // 开始时间
      endTime: '', // 结束时间
      typeCode: null, // 101出金 102入金 null 其它
      page: 0,
      size: 15,
      sort: [
        {
          direction: 'DESC',
          property: 'occurTime'
        }
      ]
    }
  },

  // firmId查询(已开通市场查询)
  param_firmIdSearch: {
    url: '/authn/authn/getFirmListByUserId',
    param: {}
  }
}
